import { render, staticRenderFns } from "./PanelCand.vue?vue&type=template&id=130c2c9d&"
import script from "./PanelCand.vue?vue&type=script&lang=js&"
export * from "./PanelCand.vue?vue&type=script&lang=js&"
import style0 from "./PanelCand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports